<div a-context-popup
     [title]="'Attach From'"
     (close)="onClose()"
>
  <p a-context-menu-item (click)="onClickAddFile()">Computer</p>
  <p a-context-menu-item (click)="onClickDropbox()">Dropbox</p>
  <p a-context-menu-item (click)="onClickGoogle()">Google Drive</p>
</div>
